'use client';

import { Skeleton } from '@castlery/fortress';

export const ProductConfigSkeleton = () => {
  return <Skeleton />;
};
